export default __webpack_public_path__ + "assets/83b5e02a46ffa1d56a4bda72624d7c01.svg";